import { styled } from 'styled-components'

import {
  useAccessToken,
  useDecodedAccessToken,
} from '@b-stock/fe-core/bstock-next/components'
import { downloadFile } from '@b-stock/fe-core/bstock-next/helpers'
import { useSavedFiles } from '@b-stock/fe-core/bstock-next/hooks'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, FileInfoLine } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'
import type { MediaDto } from '@b-stock/listing-api-client'

import { AccordionCard } from '@/buyer-portal/components/layouts/CardLayout/card/AccordionCard'

const ns = 'Offerings.Details'

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`

const Description = styled.div`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.black};
`

const AttachmentFiles = ({ documents }: { documents: MediaDto[] }) => {
  const accessToken = useAccessToken({ required: true })
  const { data: savedFiles } = useSavedFiles(documents, accessToken)

  return (
    <CardBody>
      <Description>
        <FormattedMessage
          id={`${ns}.attachments.description`}
          values={{ count: savedFiles.length }}
        />
      </Description>
      {savedFiles.map((file) => (
        <FileInfoLine
          key={file.id}
          savedFile={file}
          handleDownload={(file) => {
            void downloadFile({
              accessToken,
              id: file.id,
              filename: file.name,
            })
          }}
        />
      ))}
    </CardBody>
  )
}

export const ListingAttachmentsCard = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const personId = useDecodedAccessToken()?.personId
  const documents = listing.lot.documents

  if (!personId || !documents?.length) return null

  return (
    <AccordionCard title={<FormattedMessage id="Auction.title.attachments" />}>
      <AttachmentFiles documents={documents} />
    </AccordionCard>
  )
}
